import React from 'react'
import Game from './Game'

function App() {
  return <div id="app"><Game /></div>
}

export default App
